import { useState } from "react";
import { Dayjs } from "dayjs";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { OutlinedInputProps } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { pl } from "date-fns/locale";
import styled from "styled-components";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { theme } from "../../../../../helpers/theme";
import { Input } from "../../../../../components/Input/input";
import React from "react";

interface DatePickersProps {
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  setFromDate: (fromDate: Dayjs | null) => void;
  setToDate: (toDate: Dayjs | null) => void;
  setDateFromError: (error: string | null) => void;
  setDateToError: (error: string | null) => void;
}
const OfferDatePickers = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  setDateFromError,
  setDateToError,
}: DatePickersProps) => {
  const [inputFromMargin, setInputFromMargin] = useState(false);
  const [inputToMargin, setInputToMargin] = useState(false);
  return (
    <LocalizationProvider adapterLocale={pl} dateAdapter={AdapterDateFns}>
      <DatePickersWrapper>
        <DesktopDatePicker
          views={["day"]}
          label="Data od"
          disablePast
          value={fromDate}
          InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
          onChange={(newValue) => {
            setFromDate(newValue);
            setInputFromMargin(true);
          }}
          onError={(error) => setDateFromError(error)}
          renderInput={(params) => (
            <InputWrapper>
              <Input
                {...params}
                helperText={null}
                variant="filled"
                sx={{
                  width: "100%",
                  // minWidth: "300px",
                }}
              />
            </InputWrapper>
          )}
        />

        <DesktopDatePicker
          views={["day"]}
          label="Data do"
          disablePast
          minDate={fromDate}
          value={toDate}
          InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
          onChange={(newValue) => {
            setToDate(newValue);
            setInputToMargin(true);
          }}
          onError={(error) => setDateToError(error)}
          renderInput={(params) => (
            <InputWrapper>
              <Input
                {...params}
                helperText={null}
                variant="filled"
                sx={{
                  //  marginRight: "13px",
                  width: "100%",
                  // minWidth: "300px",
                }}
              />
            </InputWrapper>
          )}
        />
      </DatePickersWrapper>
    </LocalizationProvider>
  );
};

export default OfferDatePickers;

const DatePickersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${theme.device.Mlaptop} {
    flex-direction: column;
    gap: 10px;
  }
  width: 100%;
`;
const InputWrapper = styled.div`
  width: 300px;

  @media ${theme.device.Mlaptop} {
    width: 100%;
  }
`;
